import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { MachineSlaveDataServiceBase } from './machine-slave-data.service';
import { Medium, MediumService, MediumVersion } from 'src/api/generated';


@Injectable({
  providedIn: 'root'
})
export class MachineMediumService extends MachineSlaveDataServiceBase<Medium, string, MediumService> {
  private _medVerSrc: BehaviorSubject<MediumVersion[]> = new BehaviorSubject<MediumVersion[]>([]);
  public medVerSrc$: Observable<MediumVersion[]> = this._medVerSrc.asObservable();
  public loadingVer: boolean = true;

  constructor(
    injector: Injector,
    private _msvc:MediumService,
    private _http: HttpClient,
  ) {
    super(injector, _msvc);
  }

  protected override Init(): void {
    super.Init()
    this.currentRow$.subscribe({
      next: (r) => {
        this.refreshMediumVersions();
      }
    })
  }

  private refreshMediumVersions(): void {
    if (this._currentRow != undefined && this._currentRow.value?.Id != undefined) {
      this.loadingVer = true;
      this._msvc.postAllVersionsMediumId(this._currentRow.value?.Id, {
        Take: 1000,
        Skip: 0
      }).subscribe({
        next: res => {
          this._medVerSrc.next((res.data ?? []) as MediumVersion[]);
          setTimeout(() => {
            this.loadingVer = false;
          }, 100);
        },
        error: err => {
          setTimeout(() => {
            this.loadingVer = false;
          }, 100);
        }
      });
    }
  }

  public Checkout(id: string): void {
    this._msvc.getCheckoutMedium(id).subscribe({
      next: () => {
        this.refreshMediumVersions();
      },
      error: (e: HttpErrorResponse) => {
        this._msgSvc.ShowError(e.message);
      }
    });
  }

  public Delete(id: string): void {
    this._msvc.softDelete(id).subscribe({
      next: () => {
        this.refreshMediumVersions();
        this.reloadDataSource();
      },
      error: (e: HttpErrorResponse) => {
        this._msgSvc.ShowError(e.message);
      }
    });
  }

  public downloadMediumVersionByIdMedium(id: string): Observable<any> {
    // Must be created manually, because openapi-generator does not support returning httpResponses only the body. File name is in the header.
    return this._http.get(`${this._baseUrl}/api/Medium/download/versionById/${id ?? ""}`,
      {
        observe: 'response',
        responseType: 'blob' as 'json'
      }).pipe(
        map((res: any) => {
          if (res != null && res.body != null) {
            let tmp = res.headers.get('content-disposition');
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(tmp);
            const filename = matches != null && matches[1] ? matches[1].replace(/['"]/g, '') : null;
            const data = {
              file: new Blob([res.body], { type: res.headers.get('Content-Type') ?? "application/zip" }),
              fileName: filename,
            }
            return data;
          }
          return null;
        })
      );
  }
}
